var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { ButtonGroup } from "@atlaskit/button";
import { Button } from "@atlassiansox/microscopekit";
import CheckIcon from "@atlaskit/icon/glyph/check";
import CrossIcon from "@atlaskit/icon/glyph/cross";
import { useMutationUI } from "../../../hooks";
import { UpdateWargameExerciseStatusMutation } from "../../../graphql";
import { wargameExerciseStatuses } from "../../../models";
import { FormModal } from "../../../components";
export var ExerciseStatusButtons = function (_a) {
    var exerciseId = _a.exerciseId, exerciseStatus = _a.exerciseStatus;
    var isCompleteVisible = exerciseStatus === wargameExerciseStatuses.executeExperiments.name;
    var isCancelVisible = exerciseStatus !== wargameExerciseStatuses.cancelled.name &&
        exerciseStatus !== wargameExerciseStatuses.done.name;
    var _b = __read(useState(false), 2), isConfirmationModalVisible = _b[0], setIsConfirmationModalVisible = _b[1];
    var showConfirmationModal = function () { return setIsConfirmationModalVisible(true); };
    var hideConfirmationModal = function () { return setIsConfirmationModalVisible(false); };
    var _c = __read(useState(""), 2), updatedStatus = _c[0], setUpdatedStatus = _c[1];
    var onComplete = function () {
        setUpdatedStatus(wargameExerciseStatuses.done.name);
        showConfirmationModal();
    };
    var onCancel = function () {
        setUpdatedStatus(wargameExerciseStatuses.cancelled.name);
        showConfirmationModal();
    };
    var _d = useMutationUI({
        mutation: UpdateWargameExerciseStatusMutation,
        options: {
            onCompleted: hideConfirmationModal
        },
        successMessage: "Exercise updated successfully"
    }), mutate = _d.mutate, isLoading = _d.isLoading;
    var onConfirm = function () {
        return mutate({ variables: { exerciseID: exerciseId, status: updatedStatus } });
    };
    var confirmationTitle = updatedStatus === wargameExerciseStatuses.cancelled.name
        ? "Cancel Exercise"
        : "Complete Exercise";
    var confirmationMessage = updatedStatus === wargameExerciseStatuses.cancelled.name
        ? "Are you sure you want to cancel this exercise? This action is irreversible"
        : "Are you sure you want to complete this exercise? This action is irreversible";
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonGroup, null,
            isCompleteVisible && (React.createElement(Button, { appearance: "primary", onClick: onComplete, iconBefore: React.createElement(CheckIcon, { label: "complete", size: "small" }) }, "Mark as Done")),
            isCancelVisible && (React.createElement(Button, { appearance: "danger", onClick: onCancel, iconBefore: React.createElement(CrossIcon, { label: "cancel", size: "small" }) }, "Cancel"))),
        React.createElement(FormModal, { isOpen: isConfirmationModalVisible, onClose: hideConfirmationModal, heading: confirmationTitle, actions: {
                submit: { text: "Yes", onSubmit: onConfirm, isSubmitting: isLoading },
                close: { text: "No", onClose: hideConfirmationModal }
            } }, confirmationMessage)));
};
